// Sistema di internazionalizzazione per Foundly
// Italiano (IT) e Inglese (EN)

export const translations = {
  it: {
    // Header & Navigation
    nav: {
      home: 'Home',
      similar: 'Artisti o brani simili',
      similarShort: 'Simili',
      daily: 'Approfondimento',
      dailyShort: 'Daily',
      approfondimenti: 'Approfondimenti',
      random: 'Casuali',
      coffee: 'Offrimi un caffè'
    },

    // Home Page
    home: {
      claim: 'Scopri musica senza keyword',
      intro: 'Poco tempo, solite playlist, stessa musica. Chiedimi quello che vuoi ascoltare, qualsiasi cosa, e lasciami pensare. Ascolta cosa ho scelto oggi per te o pesca casualmente dal mazzo.',
      similarArtists: {
        title: 'Cosa vuoi ascoltare?',
        description: 'Non servono keyword. Dimmi il tuo mood, che genere cerchi o cosa ti piace. Ci penso io a consigliarti artisti giusti.'
      },
      dailyDiscovery: {
        title: 'Approfondimento giornaliero',
        description: 'Ogni giorno mi viene in mente qualcosa di diverso, un approfondimento su un genere, un periodo o solo in base a come mi sono svegliato.'
      },
      approfondimenti: {
        title: 'Approfondimenti',
        description: 'Esplora tutti gli approfondimenti: generi, epoche e playlist curate. Scegli quello che ti ispira.'
      },
      randomArtists: {
        title: 'Randomizziamoci',
        description: 'Vedi che succede, io non c\'entro niente. Potresti trovare il tuo nuovo artista preferito o qualcosa di inascoltabile. È il bello del caso.'
      }
    },

    randomHero: {
      subtitle: 'Oggi ti senti fortunato o vuoi solo farti del male?',
      cta: 'Genera consigli random'
    },

    // Daily Discovery
    dailyDiscovery: {
      loading: 'Caricamento approfondimento...',
      noDiscovery: 'Nessun approfondimento disponibile',
      discoverArtists: 'Scopri gli Artisti',
      selectDiscovery: 'Seleziona un approfondimento',
      allDiscoveries: 'Tutti gli approfondimenti',
      loadingList: 'Caricamento lista...',
      noOtherDiscoveries: 'Nessun altro approfondimento disponibile',
      wallTitle: 'Approfondimenti',
      wallSubtitle: 'Scegli un approfondimento e scopri gli artisti',
      backToWall: 'Tutti gli approfondimenti',
      readMore: 'Leggi di più',
      readLess: 'Mostra meno',
      artistsTitle: 'Artisti'
    },

    // Coffee Page
    coffee: {
      title: 'Un caffè non si rifiuta mai',
      subtitle: 'Il server costa, il mio tempo meno, il caffè è fondamentale.',
      description1: 'Sviluppare Foundly richiede notti insonni, server che girano e tanta pazienza. Se ti piace quello che vedi (o senti), offrimi un caffè. Non cambierà il mondo, ma mi aiuterà a tenere tutto online senza impazzire.',
      description2: '',
      donateButton: 'Grazie del caffè',
      thankYou: 'Grazie per aver considerato una donazione!'
    },

    // Landing Page
    landing: {
      welcome: 'Benvenuto su Foundly',
      tagline: 'Poco tempo, solite playlist, stessa musica. Chiedimi quello che vuoi ascoltare, qualsiasi cosa e lasciami pensare. Ascolta cosa ho scelto oggi per te o pesca casualmente dal mazzo.',
      description: '',
      discoverButton: 'Scopriamo nuova musica',
      coffeeButton: 'Un caffè non si rifiuta mai',
      byMrFoundly: 'by Mr. Foundly',
      privacyLink: 'Privacy & Cookie',
      features: {
        similar: 'Trova artisti o brani simili ai tuoi preferiti',
        daily: 'Approfondimenti musicali curati quotidianamente',
        random: 'Esplora artisti casuali'
      }
    },

    // Show Result
    showResult: {
      loading: 'Caricamento...',
      noResults: 'Nessun risultato trovato',
      searchPlaceholder: 'Cerca un artista...',
      selectArtist: 'Seleziona un artista',
      findSimilarTitle: 'Trova artisti o brani simili',
      findSimilarDesc: 'Inserisci il nome dell\'artista o del brano e selezionalo dalla lista per ricevere suggerimenti.',
      findSimilarTitleArtists: 'Trova artisti simili',
      findSimilarDescArtists: 'Inserisci il nome dell\'artista e selezionalo dalla lista per ricevere suggerimenti.',
      findSimilarTitleTracks: 'Trova brani simili',
      findSimilarDescTracks: 'Inserisci il nome del brano e selezionalo dalla lista per ricevere suggerimenti.',
      noSimilarFound: 'Nessun artista simile trovato. Prova con un altro artista.',
      noSimilarTracksFound: 'Nessun brano simile trovato. Prova con un altro brano.',
      searchAnother: 'Chiedi altro',
      backToDiscovery: 'Torna all\'Approfondimento',
      backToHome: 'Torna alla home',
      discoverMore: 'Prova ancora',
      genres: 'Generi',
      popularity: 'Popolarità',
      followers: 'Follower',
      openSpotify: 'Apri su Spotify',
      viewOnLastfm: 'Vedi su Last.fm',
      biography: 'Biografia',
      listenOn: 'Ascolta su',
      shareLink: 'Condividi link',
      albums: 'Album',
      topAlbums: 'Album Principali'
    },

    previewPlayer: {
      noPreview: 'Nessuna anteprima disponibile.'
    },

    // Gemini Loading Screen
    geminiLoading: {
      lookingForArtists: 'Cerco artisti simili a',
      lookingForTracks: 'Cerco brani simili a',
      dontHurry: 'Non avere fretta',
      mightTakeTime: 'la ricerca potrebbe richiedere qualche minuto'
    },

    // Common
    common: {
      back: 'Indietro',
      loading: 'Caricamento...',
      error: 'Si è verificato un errore',
      retry: 'Riprova',
      close: 'Chiudi',
      search: 'Cerca',
      cancel: 'Annulla',
      ok: 'OK'
    },
    
    // Search buttons
    searchButtons: {
      artists: 'Artisti',
      albums: 'Album',
      tracks: 'Canzone'
    },

    // New Free Text Search System (Foundly 2.0)
    freeTextSearch: {
      title: 'Cosa vuoi ascoltare?',
      description: 'Sentiti libero, spiegami e lasciami pensare.',
      placeholder: 'Puoi scrivere o parlare nella tua lingua',
      placeholderVoice: 'Premi il microfono per parlare...',
      maxWords: 'Massimo 100 parole',
      recording: 'Registrazione in corso...',
      recordingTime: 'Tempo rimanente: {seconds}s',
      stopRecording: 'Ferma registrazione',
      transcribing: 'Trascrizione in corso...',
      send: 'Invia',
      clear: 'Pulisci',
      wordsCount: '{count}/100 parole',
      wordsLabel: 'parole',
      voiceNotSupported: 'Riconoscimento vocale non supportato nel tuo browser',
      voiceError: 'Errore durante la registrazione',
      // Recording modal (popup)
      recordingModalTitle: 'Registrazione vocale',
      recordingModalHint: 'Premi Record, parla (max 30 secondi), poi Stop. Il testo apparirà nella barra.',
      recordingModalRecord: 'Record',
      recordingModalStop: 'Stop',
      recordingModalRecording: 'Registrazione in corso...',
      recordingModalTimeLeft: 'Tempo rimanente: {seconds} s',
      recordingModalTranscribing: 'Trascrizione in corso...',
      recordingModalStarting: 'Avvio riconoscimento vocale...',
      recordingModalNoSpeech: 'Nessun parlato rilevato. Riprova più vicino al microfono.',
      recordingModalMicDenied: 'Permesso microfono negato. Abilitalo nelle impostazioni del browser.',
      recordingModalMicUnavailable: 'Microfono non disponibile su questo dispositivo/browser.',
      recordingModalNetworkError: 'Errore di rete durante il riconoscimento vocale.',
      recordingModalTapToRecord: 'Clicca per registrare (massimo 30 secondi)',
      recordingModalTapToStop: 'Clicca per fermare la registrazione',
      recordingModalClose: 'Chiudi',
      recordingModalMaxDuration: 'Durata massima 30 secondi.',
      howToAsk: 'Come chiedere a Foundly',
      howToAskTitle: 'Come funziona',
      howToAskDesc: 'Foundly ti aiuta a trovare musica basandosi su una descrizione testuale o vocale della tua richiesta.',
      howToAskInstructions: [
        'Puoi menzionare artisti specifici che ti piacciono',
        'Puoi citare canzoni che vorresti sentire',
        'Puoi indicare generi musicali preferiti',
        'Puoi descrivere il tuo mood o atmosfera cercata',
        'Puoi combinare più elementi: "rock anni 80 come Queen ma più moderno"',
        'Puoi specificare lingua, popolarità o provenienza geografica'
      ],
      howToAskExample: 'Esempio: "Voglio qualcosa come The Beatles ma più rock, con chitarre potenti e un mood energetico, in inglese"',
      invalidRequest: 'Non ho abbastanza informazioni per consigliarti musica. Per favore, fornisci più dettagli su artisti, generi o atmosfera che cerchi.',
      analyzing: 'Analizzando la tua richiesta...',
      generating: 'Generando raccomandazioni...'
    },

    privacy: {
      linkLabel: 'Privacy & Cookie',
      modalTitle: 'Informativa Privacy & Cookie',
      close: 'Chiudi'
    },

    cookieBanner: {
      title: 'Cookie essenziali e Analytics',
      description: 'Usiamo solo cookie tecnici e Google Analytics anonimo. Senza consenso GA4 non parte.',
      accept: 'Accetta',
      reject: 'Rifiuta',
      learnMore: 'Scopri di più',
      analyticsLabel: 'Analytics anonimi (GA4)',
      analyticsDescription: 'Ci aiutano a capire quali sezioni funzionano meglio. Dati aggregati, nessuna profilazione.'
    }
  },

  en: {
    // Header & Navigation
    nav: {
      home: 'Home',
      similar: 'Similar artists or tracks',
      similarShort: 'Similar',
      daily: 'Daily discovery',
      dailyShort: 'Daily',
      approfondimenti: 'Discoveries',
      random: 'Random',
      coffee: 'Buy me a coffee'
    },

    // Home Page
    home: {
      claim: 'Discover music without keywords',
      intro: 'Little time, same playlists, same music. Ask me what you want to listen to, anything, and let me think. Listen to what I picked for you today or draw randomly from the deck.',
      similarArtists: {
        title: 'What do you want to listen to?',
        description: 'No keywords needed. Tell me your mood, what genre you\'re looking for, or what you like. I\'ll take care of recommending the right artists.'
      },
      dailyDiscovery: {
        title: 'Daily discovery',
        description: 'Every day I come up with something different, a deep dive into a genre, an era, or just based on how I woke up.'
      },
      approfondimenti: {
        title: 'Discoveries',
        description: 'Browse every deep dive: genres, eras and curated picks. Choose what inspires you.'
      },
      randomArtists: {
        title: 'Let\'s randomize',
        description: 'See what happens, don\'t blame me. You might find your new favorite artist or something unlistenable. That\'s the beauty of chance.'
      }
    },

    randomHero: {
      subtitle: 'Do you feel lucky today or do you just want to hurt yourself?',
      cta: 'Generate random suggestions'
    },

    // Daily Discovery
    dailyDiscovery: {
      loading: 'Loading discovery...',
      noDiscovery: 'No discovery available',
      discoverArtists: 'Discover the Artists',
      selectDiscovery: 'Select a discovery',
      allDiscoveries: 'All discoveries',
      loadingList: 'Loading list...',
      noOtherDiscoveries: 'No other discoveries available',
      wallTitle: 'Discoveries',
      wallSubtitle: 'Pick a discovery and explore the artists',
      backToWall: 'All discoveries',
      readMore: 'Read more',
      readLess: 'Show less',
      artistsTitle: 'Artists'
    },

    // Coffee Page
    coffee: {
      title: 'Never say no to a coffee',
      subtitle: 'Servers cost money, my time less so, coffee is essential.',
      description1: 'Developing Foundly takes sleepless nights, running servers, and lots of patience. If you like what you see (or hear), buy me a coffee. It won\'t change the world, but it\'ll help me keep everything online without going crazy.',
      description2: '',
      donateButton: 'Thanks for the coffee',
      thankYou: 'Thank you for considering a donation!'
    },

    // Landing Page
    landing: {
      welcome: 'Welcome to Foundly',
      tagline: 'Little time, same playlists, same music. Ask me what you want to listen to, anything, and let me think. Listen to what I picked for you today or draw randomly from the deck.',
      description: '',
      discoverButton: 'Let\'s discover new music',
      coffeeButton: 'Never say no to a coffee',
      byMrFoundly: 'by Mr. Foundly',
      privacyLink: 'Privacy & Cookie',
      features: {
        similar: 'Find artists or tracks similar to your favorites',
        daily: 'Daily curated music insights',
        random: 'Explore random artists'
      }
    },

    // Show Result
    showResult: {
      loading: 'Loading...',
      noResults: 'No results found',
      searchPlaceholder: 'Search for an artist...',
      selectArtist: 'Select an artist',
      findSimilarTitle: 'Find similar artists or tracks',
      findSimilarDesc: 'Enter the artist or track name and select from the list to receive suggestions.',
      findSimilarTitleArtists: 'Find similar artists',
      findSimilarDescArtists: 'Enter the artist name and select from the list to receive suggestions.',
      findSimilarTitleTracks: 'Find similar tracks',
      findSimilarDescTracks: 'Enter the track name and select from the list to receive suggestions.',
      noSimilarFound: 'No similar artists found. Try another artist.',
      noSimilarTracksFound: 'No similar tracks found. Try another track.',
      searchAnother: 'Ask something else',
      backToDiscovery: 'Back to Discovery',
      backToHome: 'Back to home',
      discoverMore: 'Try again',
      genres: 'Genres',
      popularity: 'Popularity',
      followers: 'Followers',
      openSpotify: 'Open on Spotify',
      viewOnLastfm: 'View on Last.fm',
      biography: 'Biography',
      listenOn: 'Listen on',
      shareLink: 'Share link',
      albums: 'Albums',
      topAlbums: 'Top Albums'
    },

    previewPlayer: {
      noPreview: 'No previews available.'
    },

    // Common
    common: {
      back: 'Back',
      loading: 'Loading...',
      error: 'An error occurred',
      retry: 'Retry',
      close: 'Close',
      search: 'Search',
      cancel: 'Cancel',
      ok: 'OK'
    },
    
    // Search buttons
    searchButtons: {
      artists: 'Artists',
      albums: 'Album',
      tracks: 'Track'
    },

    // Gemini Loading Screen
    geminiLoading: {
      lookingForArtists: 'Looking for similar artists to',
      lookingForTracks: 'Looking for similar tracks to',
      dontHurry: 'Don\'t be in a hurry',
      mightTakeTime: 'the search might take a few minutes'
    },

    // New Free Text Search System (Foundly 2.0)
    freeTextSearch: {
      title: 'What do you want to listen to?',
      description: 'Feel free, explain it to me and let me think.',
      placeholder: 'You can write or speak in your language',
      placeholderVoice: 'Press microphone to speak...',
      maxWords: 'Maximum 100 words',
      recording: 'Recording...',
      recordingTime: 'Time remaining: {seconds}s',
      stopRecording: 'Stop recording',
      transcribing: 'Transcribing...',
      send: 'Send',
      clear: 'Clear',
      wordsCount: '{count}/100 words',
      wordsLabel: 'words',
      voiceNotSupported: 'Voice recognition not supported in your browser',
      voiceError: 'Error during recording',
      // Recording modal (popup)
      recordingModalTitle: 'Voice recording',
      recordingModalHint: 'Press Record, speak (max 30 seconds), then Stop. The text will appear in the bar.',
      recordingModalRecord: 'Record',
      recordingModalStop: 'Stop',
      recordingModalRecording: 'Recording...',
      recordingModalTimeLeft: 'Time left: {seconds} s',
      recordingModalTranscribing: 'Transcribing...',
      recordingModalStarting: 'Starting voice recognition...',
      recordingModalNoSpeech: 'No speech detected. Try again closer to the microphone.',
      recordingModalMicDenied: 'Microphone permission denied. Enable it in your browser settings.',
      recordingModalMicUnavailable: 'Microphone is not available on this device/browser.',
      recordingModalNetworkError: 'Network error during voice recognition.',
      recordingModalTapToRecord: 'Tap to record (maximum 30 seconds)',
      recordingModalTapToStop: 'Tap to stop recording',
      recordingModalClose: 'Close',
      recordingModalMaxDuration: 'Maximum duration 30 seconds.',
      howToAsk: 'How to ask Foundly',
      howToAskTitle: 'How it works',
      howToAskDesc: 'Foundly helps you find music based on a text or voice description of your request.',
      howToAskInstructions: [
        'You can mention specific artists you like',
        'You can cite songs you\'d like to hear',
        'You can indicate preferred musical genres',
        'You can describe your mood or desired atmosphere',
        'You can combine multiple elements: "80s rock like Queen but more modern"',
        'You can specify language, popularity or geographic origin'
      ],
      howToAskExample: 'Example: "I want something like The Beatles but more rock, with powerful guitars and an energetic mood, in English"',
      invalidRequest: 'I don\'t have enough information to recommend music. Please provide more details about artists, genres or atmosphere you\'re looking for.',
      analyzing: 'Analyzing your request...',
      generating: 'Generating recommendations...'
    },

    privacy: {
      linkLabel: 'Privacy & Cookie',
      modalTitle: 'Privacy & Cookie Notice',
      close: 'Close'
    },

    cookieBanner: {
      title: 'Essential cookies & Analytics',
      description: 'We only use technical cookies and anonymous GA4. Without consent GA stays disabled.',
      accept: 'Accept',
      reject: 'Reject',
      learnMore: 'Learn more',
      analyticsLabel: 'Anonymous analytics (GA4)',
      analyticsDescription: 'They help us understand which sections work best. Aggregated data, no profiling.'
    }
  }
};

// Rileva la lingua del browser
export const detectLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // Se il browser è in italiano, usa italiano, altrimenti inglese
  return browserLang.toLowerCase().startsWith('it') ? 'it' : 'en';
};

// Hook personalizzato per usare le traduzioni
export const useTranslation = (language) => {
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key; // Restituisce la chiave se la traduzione non esiste
      }
    }
    
    return value || key;
  };

  return { t };
};

